const appName = process.env.REACT_APP_APP_NAME;

if (!appName) {
	throw new Error('Missing REACT_APP_APP_NAME environment variable');
}

export const APP_NAME = appName;